import { MenuItem, styled, Skeleton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";

export const LoadingHeader = styled(Skeleton)(() => ({
  width: "inherit !important",
  height: "73px !important",
  transform: "none !important",
  margin: "24px 24px 0",
}));

export const LoadingLeft = styled(Skeleton)(() => ({
  width: "100% !important",
  height: "366px !important",
  transform: "none !important",
  marginBottom: "32px !important",
}));

export const LoadingRight = styled(Skeleton)(() => ({
  width: "40% !important",
  height: "764px !important",
  transform: "none !important",
}));

export const LoadingContent = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  width: "100% !important",
  justifyContent: "space-between !important",
  padding: "24px",
}));

export const LoadingSide = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "58% !important",
}));

export const OrderPickButtonContainer = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "space-between",

  "@media (min-width: 600px)": {
    justifyContent: "flex-start",
    gap: "20px",
  },
}));

export const OrderPickText = styled("span")(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  lineHeight: "28px",
  letterSpacing: "0.15px",

  color: colors.gray800,
  fontSize: "22px",
  fontWeight: 700,

  "& > span": {
    color: colors.gray600,
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: "22px",
    lineHeight: "28px",
    letterSpacing: "0.15px",
  },
}));

export const Divider = styled("div")(() => ({
  backgroundColor: "#E4E7EC",
  height: "1px",
  margin: "8px 0px",
}));

export const ButtonOrders = styled("div")(({ open }: { open: boolean }) => ({
  "&:hover": {
    backgroundColor: "#6670851F",
  },
  [open ? "backgroundColor" : ""]: "#6670851F",
  padding: "8px",
  borderRadius: "8px",
  cursor: "pointer",
  width: "36px",
  height: "36px",
}));

export const ShipmentMenuItem = styled(MenuItem)(({ active = false }: { active?: boolean }) => ({
  backgroundColor: active ? "rgba(0, 85, 164, 0.12)" : "transparent",
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  padding: "14px 12px !important",
  width: "100%",
}));

interface TrackingWrapper {
  hasPadding?: boolean;
}
export const TrackingComponentWrapper = styled("div")(
  ({ hasPadding = false }: TrackingWrapper) => ({
    padding: hasPadding ? "16px 24px" : "0",
    "@media screen and (max-width: 425px)": {
      padding: hasPadding ? 16 : "0",
    },
  })
);

export const PickOrderWrapper = styled("div")(() => ({
  width: "100%",
}));

const styles = makeStyles(() => ({
  paperMenu: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",

    height: "fit-content",
    maxHeight: "188px",
    maxWidth: "269px",
    padding: "12px 0",
    width: "100%",

    "& ul": {
      padding: "0px",
      width: "100%",
    },

    "&::-webkit-scrollbar": {
      display: "none",
    },

    "&::-webkit-scrollbar-thumb": {
      display: "none",
    },
  },
}));

export default styles;
